import type {UserState} from './types'
import {type UserAction, UserActionType} from '../actions'

export const initialUserState: UserState = {
  isAuthenticated: false,
  claimsPending: false,
  claims: null,
  claimsError: null,
}

export function userReducer(state = initialUserState, action: UserAction): UserState {
  if (action.type === UserActionType.CLAIMS_CLEAR) {
    return {
      ...state,
      claimsPending: false,
      claims: null,
      isAuthenticated: false,
      claimsError: null
    }
  }

  if (action.type === UserActionType.CLAIMS_PENDING) {
    return {
      ...state,
      claimsPending: true,
      claimsError: null
    }
  }

  if (action.type === UserActionType.CLAIMS_FULFILLED) {
    return {
      ...state,
      claimsPending: false,
      claims: action.payload,
      isAuthenticated: true
    }
  }

  if (action.type === UserActionType.CLAIMS_REJECTED) {
    return {
      ...state,
      claimsPending: false,
      claimsError: action.payload.error,
      claims: null,
      isAuthenticated: false
    }
  }

  return state
}
